import "./TabsGlossary.scss";
import clsx from "clsx";
import React, { PropsWithChildren, ReactNode, useState } from "react";
import { Loader, Row } from "@/components";

type TabItem = {
  label: string;
  disabled?: boolean;
};

type ActionItem = PropsWithChildren<{
  label: string;
  icon: ReactNode;
  onClick: () => void;
  loading?: boolean;
}>;

type TabsGlossaryProps = {
  CTA?: "link" | "primary";
  navigationItems: TabItem[];
  activeIndex: number;
  onTabChange: (index: number) => void;
  actions?: ActionItem[];
  children?: ReactNode;
  // onDownload?: () => void;
  // onAdd?: () => void;
  // downloadAllLabel?: string;
  // addDocumentLabel?: string;
  // actionType?: "download" | "add" | null;
};

export const TabsGlossary = ({
  CTA = "link",
  navigationItems,
  children,
  activeIndex = 0,
  onTabChange,
  actions = [],
  // onDownload,
  // onAdd,
  // downloadAllLabel = "Scarica tutti",
  // addDocumentLabel = "Aggiungi documento",
  // actionType,
}: TabsGlossaryProps) => {
  const [active, setActive] = useState(activeIndex);

  // const isDownloading = loading && actionType === "download";
  // const isAdding = loading && actionType === "add";

  return (
    <div>
      <div className={clsx("ui-document-container-tabs")}>
        <nav
          className={"ui-document-container-tabs-nav-new"}
          aria-label="Menu di navigazione"
        >
          <Row
            fw={"semibold"}
            text={"secondary"}
            className={clsx(
              "ui-document-container-tabs-nav list-style-none ui-tabs",
            )}
            as="ul"
          >
            {navigationItems.map((item, index) => {
              return (
                <li
                  key={index}
                  className={clsx(
                    "ui-document-container-tabs-nav-responsive-flex ui-text-center-col fs-6 md-fs-custom",
                    !item.disabled ? "cursor-pointer" : "text-muted",
                    "ui-tab",
                    active === index && "text-primary ui-active-tab-glossary",
                  )}
                  onClick={() => {
                    if (!item.disabled) {
                      setActive(index);
                      onTabChange(index);
                    }
                  }}
                >
                  <a className={"text-decoration-none"}>{item.label}</a>
                </li>
              );
            })}
          </Row>
        </nav>
        {children}
        {CTA === "link" && (
          <nav className={"ui-document-container-tabs-nav-new"}>
            <ul className="list-style-none base-row gap-x20 fw-semibold text-primary fs-7 pb-x8">
              {actions.map((action, index) => (
                <React.Fragment key={index}>
                  <li
                    className={clsx(
                      !action.loading && "cursor-pointer",
                      "text-primary base-row justify-content-center align-items-center gap-x8",
                    )}
                    onClick={() => !action.loading && action.onClick()}
                  >
                    {action.icon}
                    <p>{action.label}</p>
                    {action.loading && <Loader loading={action.loading} />}
                  </li>
                  {index < actions.length - 1 && (
                    <li>
                      <span className="ui-divider"></span>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};
